// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__bAQzU","secondaryColor":"Notification_secondaryColor__hgCxW Notification_notification__bAQzU"};